import React from 'react'

import { Link } from 'react-router-dom';

const Fashion = () => {

    

    return (
        <>
            <marquee behavior="scroll" scrollamount="14" bgcolor="#fdc800" height="40pxl">
                <h3> India's First Online Parlor and Fashion Designinig Institute Registration Apply Easy 3 Step</h3>
            </marquee>


            <div className="slider1-area overlay-default">
                <div className="bend niceties preview-1">
                    <div id="ensign-nivoslider-3" className="slides">
                        <img src="/images/Fashion_img/fashion1.jpg" alt="slider" title="#slider-direction-1" />
                        <img src="/images/Fashion_img/fashion2.jpg" alt="slider" title="#slider-direction-2" />

                    </div>
                    <div id="slider-direction-1" className="t-cn slider-direction">
                        <div className="slider-content s-tb slide-1">
                            <div className="title-container s-tb-c">
                                <div className="slider-btn-area">
                                    <Link to='/contact' target='_blank' className="join-now-btn">Admission Enquiry</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="slider-direction-2" className="t-cn slider-direction">
                        <div className="slider-content s-tb slide-2">
                            <div className="title-container s-tb-c">
                                <div className="slider-btn-area">
                                    <Link to='/contact' target='_blank' className="join-now-btn">Admission Enquiry</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div className="shop-details-page-area">
                <div className="container">
                    <div className="row pt-5">
                        <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                            <div className="inner-shop-details">
                                <div className="product-details-info-area">
                                    <div className="row">
                                        <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                                            <div className="inner-product-details-left">
                                                <img src='/images/Fashion_img/fashion8.png' className='mt-3' />
                                            </div>
                                        </div>
                                        <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
                                            <div className="inner-product-details-right">
                                                <h3>Registrater Your Parlor and Fashion Designinig Institute with Us</h3>
                                                <ul className="learning-outcomes">
                                                    <li>Improve Your Parlor Brand Easy 3 Step</li><br />
                                                    <li>Apply Online for Basic Registration</li><br />
                                                    <li>Upload Documents</li><br />
                                                    <li>Pay Institute Registration Fee Rs.2000/- Only</li><br />
                                                    <li>Your Parlor Registration Process Complete</li><br />
                                                    <li>After Your Institute Registration Received Your Online User Name and Password</li><br />
                                                    <li>Add Your Student Admission Online </li><br />
                                                    <li>Pay Student Registration Fee Online </li><br />
                                                    <li>Dispatch Your Student Certificate By Post </li><br />
                                                </ul>
                                                <div className="form-group">
                                                    <Link to='/atcdetails' target="_blank" className="sidebar-search-btn disabled mx-2 mb-3">View Documents Details</Link>
                                                    <Link to='/atcregistration' target="_blank" className="sidebar-search-btn disabled mx-2">View Kit Details</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default Fashion